exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.input-group .form-control {\n  min-width: 50px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./src/styles.css
// module id = 847
// module chunks = 2